import { Outlet, useOutletContext, useParams } from 'react-router-dom'
import { History, LayoutDashboard, Folder } from 'lucide-react'
import { PageHeader, Tabs } from '../kit'

export default function ChartLayout() {
  const { id } = useParams()
  // Forward PatientLayout's outlet context ({ patient, setPatient }) to the
  // chart sub-routes so they can read patient.hn etc.
  const parentCtx = useOutletContext()
  // Routed tabs — no `end`, so History stays active on history/:treatmentId.
  const tabs = [
    { key: 'history', to: `/patient/${id}/chart/history`, label: 'History', icon: History, title: 'รายการการรักษาทั้งหมด' },
    { key: 'summary', to: `/patient/${id}/chart/summary`, label: 'Summary', icon: LayoutDashboard, title: 'สรุปตามฟันแต่ละซี่' },
    { key: 'file',    to: `/patient/${id}/chart/file`,    label: 'File',    icon: Folder, title: 'เอกสารและไฟล์ทั้งหมด' },
  ]
  return (
    <div>
      <PageHeader level={2} title="Chart">
        <Tabs items={tabs} />
      </PageHeader>

      <Outlet context={parentCtx} />
    </div>
  )
}
